import { AgTechVerticalPopUpMenu, AgTechVerticalPopUpMenuSection } from '@agtech/web/components/Menus/AgTechVerticalPopUpMenu';
import React from 'react'
import ContactCreditDialog from '../../dialogs/credits/SaleContactCreditDialog';
import { ContactCredit } from '@sales/data/operation/contacts/credits/ContactCreditData';
import { SaleContactCreditRemovalButton } from '../buttons/SaleContactButtons';
import { AgTechContact } from '@agtech/data/contacts/ContactData';

export type SaleContactCreditActionMenuProps = {
    contact: AgTechContact,
    credit: ContactCredit
}

const SaleContactCreditActionMenu = (props: SaleContactCreditActionMenuProps) => {
    return (
        <AgTechVerticalPopUpMenu>
            <AgTechVerticalPopUpMenuSection header="Credit">
                <ContactCreditDialog.Button contactId={props.contact.id} creditId={props.credit.id} />
                <SaleContactCreditRemovalButton contactId={props.contact.id} credit={props.credit} />
            </AgTechVerticalPopUpMenuSection>
        </AgTechVerticalPopUpMenu>
    )
};

export default SaleContactCreditActionMenu;